<template>
    <div>
        <kendo-multiselect
            v-if="loaded"
            v-model="selectedValues"
            :data-source="items"
            :data-text-field="'text'"
            :data-value-field="'id'"
            :disabled="details"
            @change="inputChanged"
            :id="'dropdown' + _uid"
            :name="'dropdown' + _uid"
            :data-vv-as="fieldName"
            :filter="filterPattern"
            :height="height"
            :footer-template="nomDropdownSettings.showFooterTemplate ? footerTemplate : ''"
            v-validate="model.isRequired || required ? 'required' : ''"
            style="width: 100%;"
        ></kendo-multiselect>
        <span
            class="text-danger col-12"
            v-if="errors.has('dropdown' + _uid)"
        >{{ errors.first('dropdown' + _uid) }}</span>

        <DropdownSettings
            v-if="loaded"
            :filterPattern.sync="filterPattern"
            :show.sync="showSettings"
        ></DropdownSettings>
    </div>
</template>

<script>
import Vue from "vue";
import FooterTemplate from "../../components/grid/NomenclatureDropdownFooterTemplate";
import DropdownSettings from "../../components/common/DropdownSettings";
import { EditorComponentModel } from "../../models/models";
import { mapGetters } from "vuex";

export default {
    inject: ["$validator"],
    props: {
        value: String,
        model: EditorComponentModel,
        details: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        fieldName: {
            type: String,
            required: false,
            default: "Unknown",
        },
        height: {
            type: Number,
            default: 400, // 200 - Default value for Kendo DropdownList
        },
    },
    components: {
        DropdownSettings,
    },
    data() {
        return {
            loaded: false,
            selectedValues: "",
            items: [],
            showSettings: false,
            filterPattern: "",
        };
    },
    methods: {
        init() {
            this.$http
                .get(
                    `/api/Dropdown/GetDynamicRegisterItems?fieldId=${this.model.id}&selected=${this.value}
                    &updateTime=${this.model.fieldValue.updateTime ? new Date(this.model.fieldValue.updateTime).toISOString() : new Date().toISOString()}`
                )
                .then((result) => {
                    this.items = result.data;
                    this.selectedValues = this.model.fieldValue.textValue.split(
                        "|"
                    );
                    this.populateStringValueById(this.selectedValues);
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: this.$t(
                            "request.response.status." +
                                this.$helpers.errorStatusCode(error)
                        ),
                        text: this.$helpers.errorText(error),
                        color: "danger",
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => {
                    this.loaded = true;
                });
        },
        inputChanged(event) {
            let valueToEmit = event.sender.value().join("|");
            this.$emit("input", valueToEmit);
            this.populateStringValueById(event.sender.value());
        },
        populateStringValueById(ids) {
            if (Array.isArray(ids) === false) {
                return;
            }

            let stringValues = [];
            let vm = this;
            ids.forEach((id) => {
                // eslint-disable-next-line eqeqeq
                const val = vm.items.filter((item) => item.id == id);
                if (val && val.length > 0) {
                    stringValues.push(val[0].text);
                }
            });
            if (stringValues.length > 0) {
                this.model.fieldValue.stringValue = stringValues.join(",");
            }
        },
        footerTemplate: function (e) {
            return {
                template: Vue.component(FooterTemplate.name, FooterTemplate),
                templateArgs: {
                    ...e,
                    btns: [
                        {
                            name: "dynamicRegisterMultiSelectSettings",
                            text: this.$t("buttons.settings.btnText"),
                            tooltip: this.$t("buttons.settings.btnText"),
                            class: "btn btn-secondary",
                            icon: "fas fa-cog",
                            show: this.nomDropdownSettings.showSettings,
                            clickHandler: () => {
                                this.showSettings = true;
                            },
                        },
                    ],
                },
            };
        },
    },
    watch: {
        selectedId: function (newVal, oldVal) {
            this.$emit("input", newVal);
        },
    },
    computed: {
        ...mapGetters(["nomDropdownSettings"]),
    },
    mounted() {
        this.filterPattern = this.nomDropdownSettings.defaultFilterPattern;
        this.init();
    },
};
</script>
